import * as React from "react";
import styled from "styled-components";
import { Color } from "../../../constants/color";

const ToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
`;

const ToggleLabel = styled.label`
  padding-left: 0.5rem;
  font-size: 16px;
  color: ${Color.LIGHT_BLUE};
  text-transform: uppercase;
  font-family: Avenir Next Bold, sans-serif;
`;

const ToggleButtonGroup = styled.div`
  display: flex;
  border: 2px solid ${Color.LIGHT_BLUE};
  border-radius: 20px;
  overflow: hidden;
  min-width: 200px;
  height: 30px;
`;

const ToggleButton = styled.button<{ $active: boolean }>`
  flex: 1;
  border: none;
  background-color: ${(props) =>
    props.$active ? Color.LIGHT_BLUE : Color.WHITE};
  color: ${(props) => (props.$active ? Color.WHITE : Color.LIGHT_BLUE)};
  font-family: Avenir Next Regular, sans-serif;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0 14px;

  &:hover {
    background-color: ${(props) =>
      props.$active ? Color.LIGHT_BLUE : Color.LIGHTER_BLUE};
  }

  &:focus-visible {
    outline: 2px solid ${Color.LIGHT_BLUE};
    outline-offset: -2px;
  }

  &:not(:last-child) {
    border-right: 1px solid ${Color.LIGHT_BLUE};
  }
`;

export interface ToggleOption {
  value: string;
  label: string;
}

export interface ToggleProps {
  label: string;
  options: ToggleOption[];
  value: string;
  onChange: (value: string) => void;
}

export const Toggle: React.FC<ToggleProps> = ({
  label,
  options,
  value,
  onChange,
}) => {
  return (
    <ToggleContainer>
      <ToggleLabel>{label}</ToggleLabel>
      <ToggleButtonGroup>
        {options.map((option) => (
          <ToggleButton
            key={option.value}
            $active={value === option.value}
            onClick={() => onChange(option.value)}
            type="button"
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </ToggleContainer>
  );
};
